import { defineMessages } from 'react-intl';
import { ReplaceMeterStep } from './enums/replaceMeterSteps';

export const RegisterStates = defineMessages({
  register: {
    id: 'app.RegisterStates.register',
    defaultMessage: 'Register {register}',
  },
  registerStatus: {
    id: 'app.common.registerStatus',
    defaultMessage: 'Stav registru',
  },
  registerRequired: {
    id: 'app.common.registerRequired',
    defaultMessage: 'Zadejte stav registru',
  },
  registerPhotos: {
    id: 'app.common.registerPhotos',
    defaultMessage: 'Fotky odečtu registru',
  },
  registerPhotosRequired: {
    id: 'app.common.registerPhotosRequired',
    defaultMessage: 'Vyfoť prosím stav registru',
  },
});

export const ReplaceMeterSteps = defineMessages<ReplaceMeterStep>({
  [ReplaceMeterStep.OldValues]: {
    id: 'app.common.replaceMeterStep.oldValues',
    defaultMessage: 'Hodnoty sterého měřidla',
  },
  [ReplaceMeterStep.NewValues]: {
    id: 'app.common.replaceMeterStep.newValues',
    defaultMessage: 'Hodnoty nového měřidla',
  },
  [ReplaceMeterStep.Details]: {
    id: 'app.common.replaceMeterStep.details',
    defaultMessage: 'Detaily',
  },
  [ReplaceMeterStep.Review]: { id: 'app.common.replaceMeterStep.review', defaultMessage: 'Rekapitulace' },
});
